import { AxiosError } from "axios";
import qs from "query-string";
import { useMutation } from "react-query";
import { NewConversationResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useConversationNameMutation = (cb: (err: boolean, msg?: string) => void) => {
  return useMutation< 
  Boolean, 
  AxiosError<any>, 
  {
    chatName: string,
    id: string
  }, 
  any>(
    async ({ chatName, id }) => {
      const {data} = await axiosClient.patch(
        `/conversation/edit/${id}`,
        { name: chatName }
      );
      return data;
    },
    {
      onError: ({ response }) => {
        cb(true, "Something went wrong.");
      },
      onSuccess: () => {
        cb(false);
      },
    }
  ); 
};
